<template>
  <div class="professor-detail">
    <div class="container">
      <h1>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="111" height="111" style="vertical-align: middle; margin-right: 12px;">
          <path d="M959.36 920.96c-15.36-181.76-139.52-332.16-307.84-386.56 70.4-45.44 117.12-124.16 117.12-214.4 0-141.44-115.2-256-256.64-256C369.92 64 255.36 178.56 255.36 320c0 90.24 46.72 168.96 117.12 214.4-168.32 54.4-292.48 204.8-307.84 386.56 0 3.2-0.64 5.76 0 10.24C65.92 947.2 80 960 96 960 113.92 960 128 945.28 128 928 144.64 730.24 310.4 576 512 576s366.72 154.24 384 352c0 17.28 14.08 32 32 32 16 0 30.08-12.8 31.36-28.8C960 926.72 959.36 924.16 959.36 920.96zM319.36 320c0-106.24 86.4-192 192.64-192 106.24 0 192.64 85.76 192.64 192 0 106.24-86.4 192-192.64 192C405.76 512 319.36 426.24 319.36 320z" fill="#bfbfbf"></path>
        </svg>
        {{ professor.name }}

      </h1>
      <h3>{{ professor.school_name }} · {{ professor.college_name }}</h3>

      <div class="rating-summary" v-if="comments.length > 0">
        <el-row>
          <el-rate show-score text-color="#ff9900" :model-value="parseFloat(averageRating.toFixed(1))" class="ml-1" score-template="{value} 分" disabled />
        </el-row>
      </div>
      <Edit style="width: 2em; height: 2em; margin-right: 8px; position: relative; left: 700px" @click="showCommentModal = true"/>
      <Share style="width: 2em; height: 2em; margin-right: 8px; position: relative; left: 700px" @click="shareLink"/>








      <!-- 展示评论列表 -->
      <div>
        <h2> <span class="comment-count">{{ comments.length }}条评价</span></h2>
        <ul>

          <li v-for="comment in comments" :key="comment.id"  >
            <br>


            <el-card style="max-width: 8800px">
              <template #header>
                <div class="card-header">
                  <el-row :gutter="20" align="middle">
                    <el-col :span="12" style="display: flex; align-items: center;">
                      <el-text style="margin-right: 8px;">匿名</el-text>
                      <el-divider direction="vertical" />
                      <el-rate
                          v-model="comment.rating"
                          :texts="['天坑导师！快逃！', '勉强能忍，但不推荐', '普普通通，不好不坏', '相当不错，值得推荐', '神仙导师！下次还选！']"
                          show-text
                          size="large"
                          disabled
                          style="margin-left: 8px;"
                      />
                    </el-col>
                    <el-col :span="12" style="text-align: right;">
                      <span style="font-size: 12px; color: #999;">创建于：{{ formatDate(comment.created_at) }}</span>
                      <span
                          v-if="formatDate(comment.created_at) !== formatDate(comment.updated_at)"
                          style="margin-left: 10px; font-size: 12px; color: #999;"
                      >
                          更新于：{{ formatDate(comment.updated_at) }}
                      </span>
                    </el-col>
                  </el-row>
                </div>
              </template>

              <p><strong>自证认识导师:</strong> {{ comment.voice_volume }}</p>
              <p><strong>学术水平:</strong> {{ comment.academic_level }}</p>
              <p><strong>科研经费:</strong> {{ comment.research_funds }}</p>
              <p><strong>学生补助:</strong> {{ comment.student_allowance }}</p>
              <p><strong>师生关系:</strong> {{ comment.teacher_student_relationship }}</p>
              <p><strong>工作时间:</strong> {{ comment.work_hours }}</p>
              <p><strong>学生前景:</strong> {{ comment.student_prospects }}</p>

              <el-row :gutter="20" align="middle">
                <el-col :span="12">

                </el-col>
                <el-col :span="1" style="text-align: right; margin-left: 200px;">
                  <div class="comment-actions">
                    <button
                        @click="upvote(comment.id)"
                        class="action-btn like-btn"
                        :class="{ 'active': comment.voteStatus?.hasUpvoted }"
                        aria-label="点赞"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path v-if="!comment.voteStatus?.hasUpvoted" fill="none" stroke="currentColor" stroke-width="1.8"
                              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                        <path v-else fill="currentColor"
                              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                      </svg>
                      <span class="count">{{ comment.upvotes }}</span>
                    </button>
                    <button
                        @click="downvote(comment.id)"
                        class="action-btn dislike-btn"
                        :class="{ 'active': comment.voteStatus?.hasDownvoted }"
                        aria-label="点踩"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024">
                        <path v-if="!comment.voteStatus?.hasDownvoted" d="M208.938667 120.874667C300.501333 79.018667 412.288 90.88 512 176.085333c99.712-85.205333 211.498667-97.066667 303.061333-55.210666C913.621333 165.888 981.333333 270.165333 981.333333 389.845333c0 117.077333-48.896 206.250667-112.213333 277.546667-50.432 56.746667-112 104.192-165.546667 145.408l-0.341333 0.298667c-12.202667 9.386667-23.978667 18.432-35.2 27.306666-21.76 17.109333-45.781333 35.968-70.314667 50.304-24.490667 14.293333-53.546667 26.624-85.717333 26.624s-61.226667-12.288-85.76-26.624c-24.490667-14.336-48.512-33.194667-70.272-50.346666-11.221333-8.832-22.997333-17.92-35.2-27.306667l-0.341333-0.256c-53.589333-41.216-115.114667-88.618667-165.546667-145.408C91.562667 596.053333 42.666667 506.88 42.666667 389.845333c0-119.68 67.754667-223.957333 166.272-268.970666z m293.546666 228.266666l119.637334 85.461334a42.666667 42.666667 0 0 1 7.594666 62.506666l-102.272 119.338667 57.386667 57.386667a42.666667 42.666667 0 0 1 11.221333 40.533333l-22.613333 90.624c12.928-9.045333 26.666667-19.712 41.813333-31.616 12.416-9.813333 25.088-19.626667 37.76-29.397333h0.042667c53.674667-41.386667 107.733333-83.072 152.277333-133.248C859.093333 550.144 896 480.298667 896 389.845333c0-87.765333-49.578667-160.853333-116.394667-191.36-63.061333-28.842667-148.778667-22.784-232.448 61.269334l-44.672 89.386666zM244.394667 198.485333C177.578667 229.034667 128 302.08 128 389.845333c0 90.453333 36.864 160.298667 90.666667 220.885334 44.544 50.176 98.645333 91.904 152.32 133.248 12.672 9.813333 25.344 19.541333 37.802666 29.397333 22.528 17.749333 41.984 32.810667 60.544 43.648 4.053333 2.389333 7.893333 4.437333 11.52 6.229333l26.581334-106.154666-68.266667-68.266667a42.666667 42.666667 0 0 1-2.218667-57.941333l97.664-113.92-111.402666-79.573334a42.666667 42.666667 0 0 1-13.354667-53.802666l49.92-99.84c-78.08-68.693333-156.501333-72.192-215.381333-45.269334z" :fill="isDisliked ? '#1890ff' : '#707070'"/>
                        <path v-else d="M208.938667 120.874667C300.501333 79.018667 412.288 90.88 512 176.085333c99.712-85.205333 211.498667-97.066667 303.061333-55.210666C913.621333 165.888 981.333333 270.165333 981.333333 389.845333c0 117.077333-48.896 206.250667-112.213333 277.546667-50.432 56.746667-112 104.192-165.546667 145.408l-0.341333 0.298667c-12.202667 9.386667-23.978667 18.432-35.2 27.306666-21.76 17.109333-45.781333 35.968-70.314667 50.304-24.490667 14.293333-53.546667 26.624-85.717333 26.624s-61.226667-12.288-85.76-26.624c-24.490667-14.336-48.512-33.194667-70.272-50.346666-11.221333-8.832-22.997333-17.92-35.2-27.306667l-0.341333-0.256c-53.589333-41.216-115.114667-88.618667-165.546667-145.408C91.562667 596.053333 42.666667 506.88 42.666667 389.845333c0-119.68 67.754667-223.957333 166.272-268.970666z m293.546666 228.266666l119.637334 85.461334a42.666667 42.666667 0 0 1 7.594666 62.506666l-102.272 119.338667 57.386667 57.386667a42.666667 42.666667 0 0 1 11.221333 40.533333l-22.613333 90.624c12.928-9.045333 26.666667-19.712 41.813333-31.616 12.416-9.813333 25.088-19.626667 37.76-29.397333h0.042667c53.674667-41.386667 107.733333-83.072 152.277333-133.248C859.093333 550.144 896 480.298667 896 389.845333c0-87.765333-49.578667-160.853333-116.394667-191.36-63.061333-28.842667-148.778667-22.784-232.448 61.269334l-44.672 89.386666zM244.394667 198.485333C177.578667 229.034667 128 302.08 128 389.845333c0 90.453333 36.864 160.298667 90.666667 220.885334 44.544 50.176 98.645333 91.904 152.32 133.248 12.672 9.813333 25.344 19.541333 37.802666 29.397333 22.528 17.749333 41.984 32.810667 60.544 43.648 4.053333 2.389333 7.893333 4.437333 11.52 6.229333l26.581334-106.154666-68.266667-68.266667a42.666667 42.666667 0 0 1-2.218667-57.941333l97.664-113.92-111.402666-79.573334a42.666667 42.666667 0 0 1-13.354667-53.802666l49.92-99.84c-78.08-68.693333-156.501333-72.192-215.381333-45.269334z" fill="#1890ff"/>
                      </svg>
                      <span class="count">{{ comment.downvotes }}</span>
                    </button>
                  </div>
                </el-col>
              </el-row>

            </el-card>
          </li>
        </ul>
      </div>

    </div>
  </div>

  <!-- 添加评论模态框 -->
  <div v-if="showCommentModal" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h3>添加评论——{{ professor.name }}</h3>
      </div>

      <form @submit.prevent="submitComment">
        <!-- 其他表单字段 -->
        <div class="form-grid">
          <div class="form-group">
            <label>自证认识导师</label>
            <el-input
                v-model="newComment.VoiceVolume"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>学术水平</label>
            <el-input
                v-model="newComment.AcademicLevel"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>科研经费</label>
            <el-input
                v-model="newComment.ResearchFunds"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>学生补助</label>
            <el-input
                v-model="newComment.StudentAllowance"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>师生关系</label>
            <el-input
                v-model="newComment.TeacherStudentRelationship"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>工作时间</label>
            <el-input
                v-model="newComment.WorkHours"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>学生前景</label>
            <el-input
                v-model="newComment.StudentProspects"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

        <div class="form-group">
          <label>评分</label>
          <el-rate
              v-model="newComment.Rating"
              :texts="['天坑导师！快逃！', '勉强能忍，但不推荐', '普普通通，不好不坏', '相当不错，值得推荐', '神仙导师！下次还选！']"
              show-text
              size="large"
              required
          />
        </div>

        </div>



        <div class="form-actions">
          <button type="submit" class="submit-btn">提交</button>
          <button type="button" class="cancel-btn" @click="showCommentModal = false">取消</button>
        </div>
      </form>
    </div>
  </div>

</template>

<script>
import BlogFooter from '@/components/BlogFooter.vue'
import CommentHeart from '@/components/CommentHeart.vue'
import axios from 'axios'
import {API_BASE_URL} from "@/config";
import { ElMessage } from 'element-plus'  // 添加这行导入
import { Delete, Edit, Search, Share, Upload } from '@element-plus/icons-vue'
import { Star, StarFilled, Close, CloseBold } from '@element-plus/icons-vue'
export default {
  name: 'ProfessorDetail',
  components: {Edit, Share, BlogFooter, CommentHeart },
  props: {
    id: String,
    name: String,
    school_name: String,
    college_name: String
  },
  data() {
    return {
      comments: [],
      voteStatus: {
        hasDownvoted: false,
        hasUpvoted: false,
        hasVoted: false
      },
      professor: {
        id: '',
        name: '',
        school_name: '',
        college_name: ''
      },
      newComment: {
        Rating: 0,
        VoiceVolume: '',  // 文本
        AcademicLevel: '',  // 文本
        ResearchFunds: '',  // 文本
        StudentAllowance: '',  // 文本
        TeacherStudentRelationship: '',  // 文本
        WorkHours: '',  // 文本
        StudentProspects: ''  // 文本
      },
      showCommentModal: false,
      hasUpvoted: false,
      hasDownvoted: false
    }
  },

  created() {
    // 这里应该从API获取教授详情
    const professorId = this.$route.params.id
    const { name, school_name, college_name } = this.$route.query
    this.professor = {
      id: professorId,
      name: name,
      school_name: school_name,
      college_name: college_name
    }
    this.fetchProfessorComments(professorId);

  },

  computed: {
    Share() {
      return Share
    },
    averageRating() {
      if (this.comments.length === 0) return 0;
      const validComments = this.comments.filter(comment =>
          !isNaN(parseFloat(comment.rating))
      );
      if (validComments.length === 0) return 0;

      const sum = validComments.reduce((total, comment) => {
        return total + parseFloat(comment.rating);
      }, 0);
      return sum / validComments.length;
    }
  },

  methods: {

    formatDate(isoString) {
      if (!isoString) return '未知日期';
      return isoString.split('T')[0]; // 直接分割ISO格式字符串，取日期部分
    },

    async submitComment() {
      if (!this.newComment.Rating) {
        ElMessage.error('请选择评分')
        return
      }
      //获取token
      const token = localStorage.getItem('access.halfpanda')
      if (!token) {
        ElMessage.error('请先登录')
        return
      }
      const formData = new FormData();
      formData.append('professor_id', this.$route.params.id);
      formData.append('Rating', this.newComment.Rating);
      formData.append('VoiceVolume', this.newComment.VoiceVolume);
      formData.append('AcademicLevel', this.newComment.AcademicLevel);
      formData.append('ResearchFunds', this.newComment.ResearchFunds);
      formData.append('StudentAllowance', this.newComment.StudentAllowance);
      formData.append('TeacherStudentRelationship', this.newComment.TeacherStudentRelationship);
      formData.append('WorkHours', this.newComment.WorkHours);
      formData.append('StudentProspects', this.newComment.StudentProspects);

      try {
        const response = await axios.post(`${API_BASE_URL}/user/comment-create`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token
          }
        });
        if (response.data.code === 200) {
          // 弹窗，评论创建成功，将邮件发送审核结果
          ElMessage.success('评论创建成功，将邮件发送审核结果')  // 添加这行
          this.showCommentModal = false;

        }
        else if (response.data.code === -1) {
          ElMessage.error('您已经对该导师发表过评论')
        }
      } catch (error) {
        console.error('创建评论失败:', error);
      }
    },

    async fetchProfessorComments(professorId) {
      try {

        const response = await axios.get(`${API_BASE_URL}/professors/comments`, {
          params: {
            professor_id: professorId
          }
        })
        if (response.data.code === 200) {
          this.comments = response.data.data
          // 为每条评论检查投票状态
          // 为每条评论检查投票状态
          this.comments = await Promise.all(this.comments.map(async comment => {
            const voteData = await this.checkVote(comment.id)
            return {
              ...comment,
              voteStatus: voteData.data || {
                hasDownvoted: false,
                hasUpvoted: false,
                hasVoted: false
              }
            }
          }))
          console.log(this.comments)
        }
      } catch (error) {
        console.error('获取评论失败:', error)
      }
    },

    async checkVote(comment_id) {
      const token = localStorage.getItem('access.halfpanda')
      try {
        const response = await axios.get(`${API_BASE_URL}/user/comment-vote/${comment_id}`,  {
              headers: {
                'Authorization': token
              }
        })
        return response.data
      } catch (error) {
        console.error('获取投票状态失败:', error);
        return {
          code: 200,
          data: {
            hasDownvoted: false,
            hasUpvoted: false,
            hasVoted: false
          }
        }
      }
    },

    async upvote(comment_id) {
      const token = localStorage.getItem('access.halfpanda')
      if (!token) {
        ElMessage.info('请先登录')
        // ElMessage.error('请先登录')
        return
      }
      try {
        const response = await axios.post(`${API_BASE_URL}/user/comment-upvote/${comment_id}`, null,{
          headers: {
            'Authorization': token
          }
        })
        const comment = this.comments.find(c => c.id === comment_id)
        if (response.data.code === 200) {  //未点赞
          comment.voteStatus.hasUpvoted = true;
          comment.voteStatus.hasDownvoted = false;
          comment.upvotes += 1;
        } else if (response.data.code === 201) {  //取消赞
          comment.voteStatus.hasUpvoted = false;
          comment.voteStatus.hasDownvoted = false;
          comment.upvotes -= 1;
        } else if (response.data.code === 202) {  //将踩改为赞
          comment.voteStatus.hasUpvoted = true;
          comment.voteStatus.hasDownvoted = false;
          comment.upvotes += 1;
          comment.downvotes -= 1;

        }
        this.$emit('update');
      }
      catch (error) {
        ElMessage.error('服务器繁忙，请稍后再试！')
      }
    },

    async downvote(comment_id) {
      const token = localStorage.getItem('access.halfpanda')
      if (!token) {
        ElMessage.info('请先登录')
        return
      }
      try {
        const response = await axios.post(`${API_BASE_URL}/user/comment-downvote/${comment_id}`, null,{
          headers: {
            'Authorization': token
          }
        })
        const comment = this.comments.find(c => c.id === comment_id)
        if (response.data.code === 200) {  //没有点过
          comment.voteStatus.hasUpvoted = false;
          comment.voteStatus.hasDownvoted = true;
          comment.downvotes += 1;
        } else if (response.data.code === 201) {  //取消踩
          comment.voteStatus.hasUpvoted = false;
          comment.voteStatus.hasDownvoted = false;
          comment.downvotes -= 1;
        } else if (response.data.code === 202) {  //将赞改为踩
          comment.voteStatus.hasUpvoted = false;
          comment.voteStatus.hasDownvoted = true;
          comment.upvotes -= 1;
          comment.downvotes += 1;
        }
        this.$emit('update');
      }
      catch (error) {
        ElMessage.error('服务器繁忙，请稍后再试！')
      }
    },

    shareLink() {
      const url = window.location.href
      navigator.clipboard.writeText(url)
          .then(() => {
            ElMessage.success('链接已复制！')
          })
          .catch(() => {
            ElMessage.error('复制链接失败，请手动复制')
          })
    }


  }
}
</script>

<style scoped>

.comment-box {
  width: 100%;
  max-width: 800px;
  min-height: 300px;
  padding: 20px;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.comment-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 7px 14px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.comment-header {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
  font-size: 0.9em;
  color: #666;
}





.comment-count {
  font-size: 0.8em;
  color: #666;
  margin-left: 10px;
  font-weight: normal;
}


.professor-detail {
  max-width: 5200px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

}
.container {
  flex: 1;
  padding: 2rem;
  max-width: 1800px;
  margin: 0 auto;
  width: 40%; /* 添加这一行 */
}
.comments {
  margin-top: 2rem;
}
.comments ul {
  list-style-type: none;
  padding: 0;
}
ul {
  list-style-type: none; /* 移除默认的圆点 */
  padding-left: 0; /* 移除默认的左内边距 */
}
.comments li {
  width: 700px; /* 固定宽度 */
  border: 1px solid #ddd;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
}






/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px; /* 增加宽度 */
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.comment-actions {
  display: flex;
  gap: 8px;
  margin-top: 0px;
}



/* 表单组间距 */
.form-group {
  margin-bottom: 20px;  /* 增加间距 */
}

/* 标签样式 */
.form-group label {
  display: block;
  margin-bottom: 10px;  /* 增加标签与输入框间距 */
  font-size: 16px;  /* 增大标签字体 */
  font-weight: 500;
  color: #333;
}

/* 评分星星大小 */
.star-rating {
  font-size: 28px;  /* 增大星星 */
}

/* 模态框内容区域 */
.modal-content {
  padding: 10px;
  width: 100%;
  max-width: 1100px; /* 增加宽度 */
}

/* 表单网格布局 */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;  /* 增加网格间距 */
}

.star-rating {
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
}

.star-rating span {
  margin-right: 5px;
}

.star-rating span.active {
  color: #ffc107;
}

.rating-description {
  margin-top: 5px;
  font-size: 14px;
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #eee;
}

.submit-btn, .cancel-btn {
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.submit-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
}

.cancel-btn {
  background-color: white;
  color: #333;
  border: 1px solid #ddd;
}


.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.5rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

/* 添加评论按钮样式 */
.add-comment-btn {
  padding: 0.5rem 1rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.add-comment-btn:hover {
  background-color: #2980b9;
}



.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 24px;
  transition: all 0.25s ease;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.action-btn svg {
  width: 20px;
  height: 20px;
  transition: all 0.25s ease;
}

.like-btn svg {
  color: #777;
}

.like-btn.active svg {
  color: #ff4d4f;
}

.dislike-btn svg {
  color: #777;
}

.dislike-btn.active svg {
  color: #1890ff;
}

.count {
  font-size: 15px;
  min-width: 18px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-weight: 400;
}

.like-btn.active .count {
  color: #ff4d4f;
  font-weight: 600;
}

.dislike-btn.active .count {
  color: #1890ff;
  font-weight: 600;
}

.star-rating span {
  cursor: pointer;
  margin-right: 8px;
  transition: all 0.2s;
}

.star-rating span.active {
  color: #FFD700;
  text-shadow: 0 0 8px rgba(255, 215, 0, 0.7);
}

.star-rating span {
  color: #FFA500;
  transform: scale(1.1);
}


.rating-description:hover {

  transform: translateY(-2px);

  padding: 8px 12px;
  background: #f8f8f8;
  border-radius: 8px;
  transition: all 0.3s;
  color: #666;
  font-size: 14px;

}


.star-rating span:hover {
  color: #f39c12;
}
</style>